export default [


  {
    path: "/approval-expenditure/list",
    name: "approval-expenditure-list",
    component: () => import("@/views/finance/approval-expenditure/listTab.vue"),
    meta: {
      action: "read",
      resource: "expenditure",
    },
  },
    {
      path: "/advance-payment/list",
      name: "advance-payment-list",
      component: () => import("@/views/finance/advance-payment/advance-payments-list/advancePaymentsList.vue"),
      meta: {
        action: "read",
        resource: "prepayments",
      },
    },
    {
      path: "/advance-payment/view/:id",
      name: "advance-payment-view",
      component: () => import("@/views/finance/advance-payment/advance-payment-view/advancePaymentView.vue"),
      meta: {
        action: "view_detail",
        resource: "prepayments",
      },
    },
    {
      path: "/advance-payment/edit/:id",
      name: "advance-payment-edit",
      component: () => import("@/views/finance/advance-payment/advance-payment-edit/advancePaymentEdit.vue"),
      meta: {
        action: "update",
        resource: "prepayments",
      },
    },
    {
      path: "/advance-payment/create",
      name: "advance-payment-create",
      component: () => import("@/views/finance/advance-payment/advance-payment-edit/advancePaymentEdit.vue"),
      meta: {
        action: "create",
        resource: "prepayments",
      },
    },



    {
      path: "/bad-debt/list",
      name: "bad-debt-list",
      component: () => import("@/views/finance/bad-debt/bad-debts-list/badDebtsList.vue"),
      meta: {
        action: "read",
        resource: "bad_debts",
      },
    },
    // {
    //   path: "/bad-debt/view/:id",
    //   name: "bad-debt-view",
    //   component: () => import("@/views/finance/bad-debt/bad-debt-view/badDebtView.vue"),
    //   meta: {
    //     action: "read",
    //     resource: "bad_debts",
    //   },
    // },
    {
      path: "/bad-debt/edit/:id",
      name: "bad-debt-edit",
      component: () => import("@/views/finance/bad-debt/bad-debt-edit/badDebtEdit.vue"),
      meta: {
        action: "update",
        resource: "bad_debts",
      },
    },
    {
      path: "/bad-debt/create",
      name: "bad-debt-create",
      component: () => import("@/views/finance/bad-debt/bad-debt-edit/badDebtEdit.vue"),
      meta: {
        action: "create",
        resource: "bad_debts",
      },
    },



    {
      path: "/expenditure/list",
      name: "expenditures-list",
      component: () => import("@/views/finance/expenditure/expenditures-list/expendituresList.vue"),
      meta: {
        action: "read",
        resource: "expenditures",
      },
    },
        
    {
      path: "/expenditure/edit/:id",
      name: "expenditure-edit",
      component: () => import("@/views/finance/expenditure/expenditures-edit/expendituresEdit.vue"),
      meta: {
        action: "update",
        resource: "expenditures",
      },
    },
    {
      path: "/expenditure/create",
      name: "expenditure-create",
      component: () => import("@/views/finance/expenditure/expenditures-edit/expendituresEdit.vue"),
      meta: {
        action: "create",
        resource: "expenditures",
      },
    },
    {
      path: "/coupon/list",
      name: "coupons-list",
      component: () => import("@/views/finance/coupon/listTab.vue"),
      meta: {
        action: "read",
        resource: "Auth",
      },
    },
    {
      path: "/coupon/edit/:id",
      name: "coupon-edit",
      component: () => import("@/views/finance/coupon/coupon/coupon-edit/couponEdit.vue"),
      meta: {
        action: "update",
        resource: "coupons",
      },
    },
    {
      path: "/coupon/create",
      name: "coupon-create",
      component: () => import("@/views/finance/coupon/coupon/coupon-edit/couponEdit.vue"),
      meta: {
        action: "create",
        resource: "coupons",
      },
    },
    {
      path: "/coupon/gift/edit/:id",
      name: "coupon-gift-edit",
      component: () => import("@/views/finance/coupon/gift/gift-edit/giftEdit.vue"),
      meta: {
        action: "update",
        resource: "gift_vouchers",
      },
    },
    {
      path: "/coupon/gift/create",
      name: "coupon-gift-create",
      component: () => import("@/views/finance/coupon/gift/gift-edit/giftEdit.vue"),
      meta: {
        action: "create",
        resource: "gift_vouchers",
      },
    },
    {
      path: "/coupon/reservation/edit/:id",
      name: "coupon-reservation-edit",
      component: () => import("@/views/finance/coupon/reservation/reservation-edit/reservationEdit.vue"),
      meta: {
        action: "update",
        resource: "reservation_voucher",
      },
    },
    {
      path: "/coupon/reservation/create",
      name: "coupon-reservation-create",
      component: () => import("@/views/finance/coupon/reservation/reservation-edit/reservationEdit.vue"),
      meta: {
        action: "create",
        resource: "reservation_voucher",
      },
    },
    {
      path: "/coupon/collection/edit/:id",
      name: "coupon-collection-edit",
      component: () => import("@/views/finance/coupon/collection/collection-edit/collectionEdit.vue"),
      meta: {
        action: "update",
        resource: "collection_voucher",
      },
    },
    {
      path: "/coupon/collection/create",
      name: "coupon-collection-create",
      component: () => import("@/views/finance/coupon/collection/collection-edit/collectionEdit.vue"),
      meta: {
        action: "create",
        resource: "collection_voucher",
      },
    },


    {
      path: "/claim/list",
      name: "claim-list",
      component: () => import("@/views/finance/claim/claims-list/claimsList.vue"),
      meta: {
        action: "read",
        resource: "claims",
      },
    },
    // {
    //   path: "/claim/view/:id",
    //   name: "claim-view",
    //   component: () => import("@/views/finance/claim/claim-view/claimView.vue"),
    //   meta: {
    //     action: "read",
    //     resource: "claims",
    //   },
    // },
    {
      path: "/claim/edit/:id",
      name: "claim-edit",
      component: () => import("@/views/finance/claim/claims-edit/claimsEdit.vue"),
      meta: {
        action: "update",
        resource: "claims",
      },
    },
    {
      path: "/claim/create",
      name: "claim-create",
      component: () => import("@/views/finance/claim/claims-edit/claimsEdit.vue"),
      meta: {
        action: "create",
        resource: "claims",
      },
    },

    // 銀行進支記錄路由
    {
      path: "/bank-records/list",
      name: "bank-records-list",
      component: () => import("@/views/finance/bank-records/bank-records-list/bankRecordsList.vue"),
      meta: {
        action: "read",
        resource: "receipts",
      },
    },

  ]